<template>
    <div id="cb-integrations">
        <div class="ml-3 mt-3">
            <div class="big-title">{{ $t("chatbotv2.allIntegrations") }}</div>
            <WebHook v-if="integrationPage === 'webhook'" />
            <div class="stories" v-else>
                <div class="story" @click="SelectStoryIntegrationWithSupsisWebModalVisible = true">
                    <div class="status" v-if="isChatWidgetInstalled()">
                        <span class="material-icons"> done </span> {{ $t("chatbotv2.installationOK") }}
                    </div>
                    <SelectStoryIntegrationWithSupsisWeb
                        :modal-visible="SelectStoryIntegrationWithSupsisWebModalVisible"
                        @modal-visible="SelectStoryIntegrationWithSupsisWebModalVisible = false"
                    />
                    <div class="img supsis">
                        <SupsisIcon />
                    </div>
                    <div class="title">{{ $t("chatbotv2.chatWidget") }}</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithChatWidget") }}</div>
                </div>
                <div class="story" @click="gotoWebhook">
                    <div class="img webhooks">
                        <WebhookIcon />
                    </div>
                    <div class="title">{{ $t("chatbotv2.webhooks") }}</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithWebHook") }}</div>
                </div>
                <div class="story" @click="showWhatsappIntegration">
                    <div class="status" v-if="isChatWidgetIntegratedWithWhatsapp()">
                        <span class="material-icons"> done </span> {{ $t("chatbotv2.installationOK") }}
                    </div>
                    <div class="img whatsapp">
                        <WhatsappIcon />
                    </div>
                    <div class="title">Whatsapp</div>
                    <div>
                        {{ $t("chatbotv2.integratePlatform", { integratable: "Whatsapp" }) }}
                        {{ $t("chatbotv2.planRequired", { integratable: "Whatsapp Plus" }) }}
                    </div>
                    <WhatsappIntegrationsModal
                        :title="$t('chatbotv2.whatsappIntegrationTitle')"
                        :channels="whatsappWebChannels"
                        :modalVisable="whatsappIntegrationModalVisible"
                        @close="whatsappIntegrationModalVisible = false"
                        @submit="whatsappIntegrationModalVisible = false"
                    />
                </div>
                <div class="story" @click="showTrendyolIntegration">
                    <div class="status" v-if="isChatWidgetIntegratedWithTrendyol()">
                        <span class="material-icons"> done </span> {{ $t("chatbotv2.installationOK") }}
                    </div>
                    <div class="img trendyol">
                        <TrendyolIcon />
                    </div>
                    <div class="title">Trendyol</div>
                    <div>
                        {{ $t("chatbotv2.integratePlatform", { integratable: "Trendyol" }) }}
                        {{ $t("chatbotv2.planRequired", { integratable: "Trendyol" }) }}
                    </div>
                    <TrendyolIntegrationsModal
                        :title="'Trendyol Chatbot Entegrasyonu'"
                        :channels="[]"
                        :modalVisable="trendyolIntegrationModalVisible"
                        @close="trendyolIntegrationModalVisible = false"
                        @submit="trendyolIntegrationModalVisible = false"
                    />
                </div>
                <div class="story" @click="showWhatsappIntergationBusinessAPI">
                    <div class="status" v-if="isChatWidgetIntegratedWithWhatsappBusinessAPI()">
                        <span class="material-icons"> done </span> {{ $t("chatbotv2.installationOK") }}
                    </div>
                    <div class="img whatsapp">
                        <WhatsappIcon />
                    </div>
                    <div class="title">Whatsapp Business API</div>
                    <div>{{ $t("chatbotv2.integratePlatform", { integratable: "Whatsapp Business API" }) }}</div>
                    <WhatsappIntegrationsModal
                        :title="$t('chatbotv2.whatsappApiIntegrationTitle')"
                        :channels="whatsappBusinessApiChannels"
                        :modalVisable="whatsappBusinessAPIIntegrationModalVisible"
                        @close="whatsappBusinessAPIIntegrationModalVisible = false"
                        @submit="whatsappBusinessAPIIntegrationModalVisible = false"
                    />
                </div>
                <div class="story" @click="showInstagramIntegration">
                    <div class="status" v-if="isChatWidgetIntegratedWithInstagram()">
                        <span class="material-icons"> done </span> {{ $t("chatbotv2.installationOK") }}
                    </div>
                    <SelectStoryIntegratingWithInstagram
                        :modal-visible="integrateInstagramModalVisible"
                        @modal-visible="integrateInstagramModalVisible = false"
                    />
                    <div class="img instagram">
                        <InstagramIcon />
                    </div>
                    <div class="title">Instagram</div>
                    <div>
                        {{ $t("chatbotv2.integratePlatform", { integratable: "Instagram" }) }}
                        {{ $t("chatbotv2.planRequired", { integratable: "Instagram Plus" }) }}
                    </div>
                </div>
                <div class="story" @click="showTelegramBotIntegration">
                    <div class="status" v-if="isChatWidgetIntegratedWithTelegramBot()">
                        <span class="material-icons"> done </span> {{ $t("chatbotv2.installationOK") }}
                    </div>
                    <SelectStoryIntegratingWithTelegramBot
                        :modal-visible="integrateTelegramBotModalVisible"
                        @modal-visible="integrateTelegramBotModalVisible = false"
                    />
                    <div class="img telegram">
                        <TelegramIcon />
                    </div>
                    <div class="title">Telegram</div>
                    <div>
                        {{ $t("chatbotv2.integratePlatform", { integratable: "Telegram" }) }}
                        {{ $t("chatbotv2.planRequired", { integratable: "Telegram Bot" }) }}
                    </div>
                </div>
                <div class="story voting" @click="">
                    <div class="img facebook">
                        <FacebookIcon />
                    </div>
                    <div class="title">Facebook</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithIntegratable", { integratable: "Facebook" }) }}</div>
                </div>
                <div class="story voting" @click="">
                    <div class="img twitter">
                        <TwitterIcon />
                    </div>
                    <div class="title">Twitter</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithIntegratable", { integratable: "Twitter" }) }}</div>
                </div>
                <div class="story voting" @click="">
                    <div class="img skype">
                        <SkypeIcon />
                    </div>
                    <div class="title">Skype</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithIntegratable", { integratable: "Skype" }) }}</div>
                </div>
                <div class="story voting" @click="">
                    <div class="img shopify">
                        <ShopifyIcon />
                    </div>
                    <div class="title">Shopify</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithIntegratable", { integratable: "Shopify" }) }}</div>
                </div>
                <div class="story voting" @click="">
                    <div class="img slack">
                        <SlackIcon />
                    </div>
                    <div class="title">Slack</div>
                    <div>{{ $t("chatbotv2.integrateYourCBwithIntegratable", { integratable: "Slack" }) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideMenuBar from "../../SideMenuBar.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import WebhookIcon from "./svg/WebhookIcon.vue";
import OpenaiIcon from "./svg/OpenaiIcon.vue";
import SupsisIcon from "./svg/SupsisIcon.vue";
import SelectStoryIntegrationWithSupsisWeb from "./components/SelectStoryIntegrationWithSupsisWeb.vue";
import WhatsappIcon from "./svg/WhatsappIcon.vue";
import InstagramIcon from "./svg/InstagramIcon.vue";
import TelegramIcon from "./svg/TelegramIcon.vue";
import TwitterIcon from "./svg/TwitterIcon.vue";
import FacebookIcon from "./svg/FacebookIcon.vue";
import SkypeIcon from "./svg/SkypeIcon.vue";
import ShopifyIcon from "../../../../../components/fast-initialize/svg/ShopifyIcon.vue";
import SlackIcon from "./svg/SlackIcon.vue";
import _ from "lodash";
import SelectStoryIntegratingWithInstagram from "./components/SelectStoryIntegratingWithInstagram.vue";
import SelectStoryIntegratingWithTelegramBot from "./components/SelectStoryIntegratingWithTelegramBot.vue";
import { PERMISSION_TYPES } from "../../../../../language/permissionTypes";
import WhatsappIntegrationsModal from "./components/WhatsappIntegrationsModal.vue";
import ChatbotMenu from "../../ChatbotMenu.vue";
import WebHook from "./pages/webhooks/WebhookList.vue";
import TrendyolIntegrationsModal from "./components/TrendyolIntegrationsModal.vue";
import TrendyolIcon from "./svg/TrendyolIcon.vue";

export default {
    name: "Integrations",
    components: {
        TrendyolIcon,
        TrendyolIntegrationsModal,
        WebHook,
        ChatbotMenu,
        SlackIcon,
        ShopifyIcon,
        SkypeIcon,
        FacebookIcon,
        TwitterIcon,
        WhatsappIcon,
        InstagramIcon,
        TelegramIcon,
        SelectStoryIntegrationWithSupsisWeb,
        SupsisIcon,
        SideMenuBar,
        WebhookIcon,
        OpenaiIcon,
        SelectStoryIntegratingWithInstagram,
        SelectStoryIntegratingWithTelegramBot,
        WhatsappIntegrationsModal,
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            channels: (state) => state.channel.channels,
            whatsappBusinessApiChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-business-api", "whatsapp-business-api-supsis"].includes(x.type)),
            whatsappWebChannels: (state) =>
                state.channel.channels.filter((x) => ["whatsapp-v1", "whatsapp-qr", "whatsapp-v2"].includes(x.type)),
            igChannels: (state) => state.channel.channels.filter((x) => ["instagram"].includes(x.type)),
            trendyolChannels: (state) => state.channel.channels.filter((x) => ["trendyol"].includes(x.type)),
            webChatChannel: (state) => state.channel.channels.find((channel) => channel.type === "webchat"),
        }),
        ...mapGetters({
            telegramBotEnabled: "setting/telegramBotEnabled",
            gpt3Enabled: "setting/gpt3Enabled",
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            listChannels: "channel/listChannels",
        }),
        gotoWebhook() {
            console.log("gotoWebhook");
            this.integrationPage = "webhook";
            // this.$router.push("/chatbot/integrations/webhook");
        },
        isChatWidgetInstalled() {
            let isChatWidgetInstalled = this.stories.find((story) => _.get(story, "integrations.supsisWidget"));
            if (!isChatWidgetInstalled && this.webChatChannel?.forward?.story) {
                isChatWidgetInstalled = this.stories.find((story) => story._id === this.webChatChannel.forward?.story);
            }
            return isChatWidgetInstalled;
        },
        isChatWidgetIntegratedWithTrendyol() {
            return !!this.stories.find((story) => _.get(story, "integrations.trendyol"));
        },
        isChatWidgetIntegratedWithWhatsappBusinessAPI() {
            return !!this.channels.find(
                (channel) =>
                    (channel.type === "whatsapp-business-api" || channel.type === "whatsapp-business-api-supsis") &&
                    channel.enabled &&
                    channel.forward &&
                    (channel.forward.mode === "hybrid" || channel.forward.mode === "chatbot"),
            );
        },
        isChatWidgetIntegratedWithWhatsapp() {
            return !!this.channels.find(
                (channel) =>
                    (channel.type === "whatsapp-v1" ||
                        channel.type === "whatsapp-v2" ||
                        channel.type === "whatsapp-qr") &&
                    channel.enabled &&
                    channel.forward &&
                    (channel.forward.mode === "hybrid" || channel.forward.mode === "chatbot"),
            );
        },
        isChatWidgetIntegratedWithInstagram() {
            return !!this.stories.find((story) => _.get(story, "integrations.instagram"));
        },
        isChatWidgetIntegratedWithTelegramBot() {
            return !!this.stories.find((story) => _.get(story, "integrations.telegram", false));
        },
        openNotificationWithIcon(featureType, type = "warning") {
            const models = {
                whatsapp: {
                    message: this.$t("message.wpIntegrationChannelRequired"),
                    description: this.$t("message.wpIntegrationChannelRequiredDesc"),
                    url: "/integrations/whatsapp-v2",
                    buttonText: this.$t("message.createWpChannel"),
                },
                whatsappBusiness: {
                    message: this.$t("message.wabaIntegrationChannelRequired"),
                    description: this.$t("message.wabaIntegrationChannelRequiredDesc"),
                    url: "/integrations/whatsapp-business-api",
                    buttonText: this.$t("message.createWabaChannel"),
                },
                instagram: {
                    message: this.$t("message.instaIntegrationChannelRequired"),
                    description: this.$t("message.instaIntegrationChannelRequiredDesc"),
                    url: "/integrations/instagram",
                    buttonText: this.$t("message.createInstaChannel"),
                },
            };
            const model = models[featureType];
            const key = `plan`;
            this.$notification[type]({
                message: model.message,
                description: model.description,
                placement: "topRight",
                onClose: () => this.$router.push(model.url),
                key,
                btn: (h) => {
                    let buttonText = model.buttonText;
                    return h(
                        "a-button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.$router.push(model.url);
                                    this.$notification.close(key);
                                },
                            },
                        },
                        buttonText,
                    );
                },
            });
        },
        showGPT3Integration(routePushMode = true) {
            if (routePushMode) this.$router.push("/chatbot/integrations");
            this.integrateChatGpt3ModalVisible = true;
        },
        showTelegramBotIntegration() {
            this.integrateTelegramBotModalVisible = true;
        },
        showTrendyolIntegration() {
            const channelExists = this.trendyolChannels.length > 0;
            if (!channelExists) {
                this.openNotificationWithIcon("trendyol");
            } else {
                this.trendyolIntegrationModalVisible = true;
            }
        },
        showWhatsappIntegration() {
            const channelExists = this.whatsappWebChannels.length > 0;
            if (!channelExists) {
                this.openNotificationWithIcon("whatsapp");
            } else {
                this.whatsappIntegrationModalVisible = true;
            }
        },
        showWhatsappIntergationBusinessAPI() {
            const channelExists = this.whatsappBusinessApiChannels.length > 0;
            if (!channelExists) {
                this.openNotificationWithIcon("whatsappBusiness");
            } else {
                this.whatsappBusinessAPIIntegrationModalVisible = true;
            }
        },
        showInstagramIntegration() {
            if (!this.igChannels.length) {
                this.openNotificationWithIcon("instagram");
            } else {
                this.integrateInstagramModalVisible = true;
            }
        },
    },
    data() {
        return {
            trendyolIntegrationModalVisible: false,
            whatsappBusinessAPIIntegrationModalVisible: false,
            whatsappIntegrationModalVisible: false,
            SelectStoryIntegrationWithSupsisWebModalVisible: false,
            integrateInstagramModalVisible: false,
            integrateTelegramBotModalVisible: false,
            integrateChatGpt3ModalVisible: false,
            type: "",
            integrationPage: null,
        };
    },
    mounted() {
        this.listStories();
        this.listChannels();
        this.type = !!this.$route.query ? this.$route.query.type : "";
        this.integrationPage = this.$route.path.replace(/(\/|chatbot|integrations)/g, "");
    },
    beforeMount() {
        if (this.checkPermission(PERMISSION_TYPES["chatbot.integrations.view"].tr.name) === false) {
            return router.push("/denied");
        }
    },
    watch: {
        type(newVal) {
            if (newVal === "gpt3") {
                this.showGPT3Integration(false);
            }
        },
        "$route.path": {
            deep: true,
            handler() {
                this.integrationPage = this.$route.path.replace(/(\/|chatbot|integrations)/g, "");
            },
        },
    },
};
</script>

<style lang="scss" scoped>
#cb-integrations {
    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .stories {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            position: relative;
            background: #fff;
            border-radius: 4px;
            padding: 20px;
            cursor: pointer;
            transition: all 0.3s;
            width: 280px;
            min-width: 250px;
            max-width: 250px;
            height: 216px;
            box-shadow: 0 1px 15px rgb(0 0 0 / 4%);
            border: 1px solid #dbe1e8;

            .status {
                background-color: #f5f8fb;
                border: 1px solid #dbe1e8;
                border-radius: 6px;
                color: #919ead;
                font-size: 12px;
                font-weight: 600;
                padding: 5px 7px;
                position: absolute;
                right: 10px;
                top: 10px;
                display: flex;
                justify-content: center;
                align-items: center;

                .material-icons {
                    float: left;
                    font-size: 15px;
                    margin-right: 5px;
                }
            }

            &.voting {
                background: #ebeef2;

                &:after {
                    background: #008aff;
                    border-radius: 6px;
                    color: #fff;
                    content: "VOTING";
                    font-size: 13px;
                    font-weight: 600;
                    padding: 5px 10px;
                    position: absolute;
                    right: 10px;
                    top: 10px;
                }
            }

            &:hover {
                .img:after {
                    transform: rotate(45deg) translate(-20%, -150%);
                    transition: all 0.4s;
                }
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }

            .img {
                width: 70px;
                height: 70px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-bottom: 15px;
                overflow: hidden;
                position: relative;

                &.webhooks {
                    background: #7159c2;
                }

                &.supsis {
                    background: #e8eef3;
                }

                &.openai {
                    background: #a2cbed;
                }

                &.whatsapp {
                    background: #58ca64;
                }

                &.instagram {
                    background: #d6249f;
                    background: radial-gradient(
                            circle at 30% 107%,
                            #fdf497 0%,
                            #fdf497 5%,
                            #fd5949 45%,
                            #d6249f 60%,
                            #285aeb 90%
                    );
                }

                &.telegram {
                    background: #29b6f6;
                }

                &.twitter {
                    background: #3ecdfb;
                }

                &.slack {
                    background: #634360;
                }

                &.facebook,
                &.skype,
                &.trendyol,
                &.shopify {
                    background: #ffffff;
                }

                svg {
                    width: 60%;
                }

                &:after {
                    background: #fff;
                    bottom: 0;
                    content: "";
                    height: 100%;
                    left: -10%;
                    opacity: 0.3;
                    position: absolute;
                    top: 0;
                    transform: rotate(45deg) translate(-20%, 150%);
                    width: 160%;
                }
            }
        }
    }
}
</style>
